/<!------------------Nitro Satış/ Satış İşlemleri-------------------->
<template>
  <div class="vx-card">
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <!-- <div class="vx-row justify-between flex">
      <div class="vx-col">
        <vs-button style="margin-top: 2px;" @click.stop="showAddNew()">Yeni Satış</vs-button>
      </div>
    </div> -->

    <form class="p-6 mb-5 card-bg" @submit.prevent="getOrderList()">
      <h1 class="p-6 text-center mb-5">Satış İşlemleri</h1>

      <div id="satis-islemleri " class="">
        <div class="id-inputs vx-row">
          <div class="vx-col islem-id mb-4 md:w-1/4 w-full">
            <label class="text-sm"><b>İşlem Id</b></label>
            <vs-input type="number" size="medium" class="w-full" v-model="autoRefreshModel.id" />
          </div>
          <div class="vx-col urun-id mb-4 md:w-1/4 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/3 w-full">
                <label class="text-sm"><b>Ürün Id</b></label>
                <vs-input type="number" class="w-full" size="medium" v-model="autoRefreshModel.productId" />
              </div>
              <div class="vx-col mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>

          <div class="vx-col musteri-id mb-4 md:w-1/4 w-full">
            <label class="text-sm"><b>Müşteri Id</b></label>
            <vs-input type="number" size="medium" class="w-full" v-model="autoRefreshModel.customerId" />
          </div>
        </div>
        <div class="satis-inputs vx-row mb-4">
          <div class="satis-baslangic vx-col mb-4 md:w-1/4 w-full">
            <label class="text-sm"><b>Başlangıç</b></label>
            <vs-input type="date" size="medium" class="w-full" v-model="autoRefreshModel.startDate" />
          </div>
          <div class="satis-bitis mb-4 vx-col md:w-1/4 w-full">
            <label class="text-sm"><b>Bitiş</b></label>
            <vs-input @change="getOrderList()" type="date" size="medium" class="w-full" v-model="autoRefreshModel.finishDate" />
          </div>
          <div class="satis-yapan mb-4 vx-col md:w-1/4 w-full">
            <label class="text-sm"><b>Satış Yapan</b></label>
            <v-select @input="getOrderList()" placeholder="Satış Yapan" label="userName" :options="personnalList" v-model="autoRefreshModel.createUserId" :reduce="(row) => row.userId">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="satis-durum mb-4 vx-col md:w-1/4 w-full">
            <label class="text-sm"><b>Satış Durum</b></label>
            <v-select @input="getOrderList()" placeholder="Durum" label="value" :options="statusList" v-model="autoRefreshModel.statusId" :reduce="(row) => row.id">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>

        <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c">
          <vs-button class="vx-col md:w-1/4 w-full mb-4" style=""> Detaylı Ara</vs-button>
          <p class="text-center md:w-1/4 mb-4"></p>
          <vs-button class="vx-col md:w-1/4 w-full" @click.stop="showAddNew()">Yeni Satış Ekle</vs-button>
        </div>
      </div>
    </form>

    <div v-if="!loading">
      <div id="sales-app">
        <div class="p-6 app-fixed-height">
          <div class="flex items-center app-search-container border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
            <!-- TOGGLE SIDEBAR BUTTON -->
            <feather-icon class="md:inline-flex ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar()"></feather-icon>

            <!-- SEARCH BAR -->
            <vs-input size="large" icon-pack="feather" icon="icon-search" placeholder="Ara..." v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus no-icon-border w-3/4" />
            <div class="w-full md:justify-end" style="display: contents;">
              <div class="flex items-center">
                <div @click="paginate(false)" class="material-icons cursor-pointer" style="transform: rotate(180deg);">play_circle_outline</div>
                <input type="text" v-model="currentPage" @input="isNumeric" class="m-2" style="width: 40px;" />&nbsp;
                <span class="mx-2" style="white-space: nowrap;">/{{ calculatedPageCount }}</span>
                <div @click="paginate(true)" class="material-icons cursor-pointer">play_circle_outline</div>
              </div>

              <div>
                <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                  <radial-progress-bar
                    :diameter="27"
                    v-if="progressBarCurrent < pageCount - 1"
                    :completed-steps="progressBarCurrent"
                    :strokeWidth="4"
                    :innerStrokeWidth="5"
                    :startColor="'#e41b1b'"
                    :stopColor="'#ff892e'"
                    :total-steps="pageCount - 1"
                  ></radial-progress-bar>
                </div>
              </div>
            </div>
          </div>

          <VuePerfectScrollbar class="sales-content-scroll-area" :settings="settings" ref="saleListPS">
            <transition-group class="sales-list" name="list-enter-up" tag="ul" appear>
              <li class="cursor-pointer sales-item" v-for="(current, index) in currentPageData" :key="current.saleOrderId" :style="{ transitionDelay: index * 0.05 + 's' }">
                <row-item
                  :serviceItem="current"
                  v-model="matchedField"
                  @showDisplayPrompt="showDisplayPrompt(current.saleOrderId)"
                  @openAssignPopup="showAssignedPopUpMenu(current.saleOrderId)"
                  @openAddMessagePopup="openAddMessagePopup(current.saleOrderId)"
                  @openTransferPopup="openTransferPopup(current.saleOrderId)"
                  @openSendEmailPopup="openSendEmailPopup(current)"
                  ref="rowItemRef"
                ></row-item>
              </li>
              <div v-if="hasNoItems" :key="-1" class="px-4 py-4 list-item-component">
                <div class="center grid">
                  <vs-row style="margin: auto;">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="12">
                      <h4>kayıt bulunamadı.</h4>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </transition-group>
          </VuePerfectScrollbar>
        </div>

        <add-new :addnew="addNewRegister" v-if="addNewRegister" @hideAddNewRegister="hideAddNew" @addedData="sentDataAfteradd"></add-new>

        <edit :displayPrompt="displayPrompt" :technicItemId="orderIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></edit>

        <!-- EDIT technic fastly -->
        <assign-popup :assignedPopUpMenu="assignedPopUpMenu" :serviceId="serviceId" :neighbourList="neighbours" @hideAssignedPopup="hideAssignedPopup" v-if="assignedPopUpMenu" @updateCompleted="assignUpdateCompleted"></assign-popup>

        <add-message-popup :serviceId="serviceId" v-if="false && addMessagePopupVisible" @updateCompleted="addMessagePopupVisible = false"></add-message-popup>

        <transfer-popup :serviceId="serviceId" v-if="false && transferPopupVisible" @updateCompleted="transferPopupVisible = false"></transfer-popup>
        <send-email-popup :currentItem="currentPopupItem" v-if="sendEmailPopupVisible" @updateCompleted="sendEmailUpdateCompleted">></send-email-popup>
      </div>
    </div>
  </div>
</template>

<script>
import AddNew from "./AddNew.vue";
import RowItem from "./RowItem.vue";
import Filters from "./Filters";
import Edit from "./Edit.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AssignPopup from "./AssignPopup.vue";
import { repository } from "@/_services/repository.js";
import { VclFacebook } from "vue-content-loading";
import AddMessagePopup from "./AddMessagePopup.vue";
import TransferPopup from "./TransferPopup.vue";
import SendEmailPopup from "./SendEmailPopup.vue";
import RadialProgressBar from "vue-radial-progress";
import vSelect from "vue-select";
import ProductSearch from "../Search/ProductSearch.vue";
export default {
  components: {
    AddNew,
    RowItem,
    Filters,
    Edit,
    VuePerfectScrollbar,
    AssignPopup,
    VclFacebook,
    AddMessagePopup,
    TransferPopup,
    SendEmailPopup,
    RadialProgressBar,
    vSelect,
    ProductSearch,
  },
  data() {
    return {
      productSearchPopupParent: false,
      personnalList: [],
      statusList: [],
      name: "Sales",
      pageSize: 20,
      currentPage: 1,
      orderTypeList: [],
      autoRefresh: false,
      chkAutoRefreshDisabled: true,
      loading: true,
      progressBarCurrent: 0,
      progressBarTotal: 0,
      orderStatusList: [],
      clickNotClose: true,
      displayPrompt: false,
      addNewRegister: false,
      assignedPopUpMenu: false,
      asignUpdateId: "",
      serviceId: 0,
      currentPopupItem: "",
      orderIdToEdit: 0,
      isSidebarActive: true,
      hasNoItems: false,
      windowWidth: window.innerWidth,
      addMessagePopupVisible: false,
      sendEmailPopupVisible: false,
      transferPopupVisible: false,
      currentPageData: [],
      neighbours: [],
      matchedField: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      lastUpdated: new Date(),
      pageCount: 1,
      orders: null,
      FilterList: [],
      Filter: { filter1: "", filter2: "", filter3: "", expired: "" },
      LastFilter: {},
      filteredItemCount: 0,
      searchQuery: "",
      autoRefreshModel: {
        id: 0,
        currentPage: 1,
      },
      lastAutoRefresh: new Date(),
      autoRefreshTimer: Number,
      autoRefreshSeconds: 10,
    };
  },
  //notification pencerelerini açabilmek için
  //displayPromptIfNotification() adında bir method oluşturuyoruz.
  //watch ve computed eventlerini aşağıdaki gibi yazıyoruz.
  //item listemizi doldurduktan sonra this.displayPromptIfNotification(); methodumuzu çağırıyoruz.
  watch: {
    notification() {
      this.displayPromptIfNotification();
    },
    Filter: {
      handler: function () {
        this.currentPage = 1;
        this.renderItems();
      },
      deep: true,
    },
    currentPage: function () {
      this.renderItems();
    },
    searchQuery: function () {
      if (this.searchQuery.length > 3 || this.searchQuery.length == 0) {
        this.matchedField = { field: "NONE", value: "" };
        this.Filter.filter3 = this.searchQueryEn;
        this.createFilterList(this.Filter);
      }
    },
  },
  computed: {
    hasAnyActiveFilter() {
      return this.Filter.filter1.length > 0 || this.Filter.filter2.length > 0 || this.Filter.filter3.length > 0;
    },
    actualPage() {
      return this.currentPage - 1;
    },
    calculatedPageCount() {
      return Math.ceil(this.filteredItemCount / this.pageSize);
    },
    searchQueryEn() {
      return repository.convertToEnglish(this.searchQuery.trim().toLowerCase());
    },
    filterQueryEn() {
      return repository.convertToEnglish(this.Filter.filter3.trim().toLowerCase());
    },
    notification() {
      return this.$store.state.notifications;
    },
  },
  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.autoRefreshModel.productId = v.productId;
      } else {
        this.autoRefreshModel.productId = null;
      }
    },

    getUsers: async function () {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnalList = r.list;
      });

      return this.personnalList;
    },

    GetStatusList: async function () {
      await repository.getAll("Sale/GetStatusList").then((r) => {
        this.statusList = r.list;
      });
    },

    isNumeric() {
      let c = parseInt(this.currentPage);
      if (isNaN(c)) c = 1;
      this.currentPage = c;
    },
    renderItems() {
      let currentPageData = [];
      this.currentPageData = [];
      if (!this.hasAnyActiveFilter) {
        this.filteredItemCount = this.FilterList.length;
        for (let i = 0; i < this.FilterList.length; i++) {
          this.FilterList[i].show = false;
          //herhangi bir filtre yok ise
          if (i >= this.pageSize * this.actualPage && i < this.pageSize * (this.actualPage + 1)) {
            this.FilterList[i].show = true;
            currentPageData.push(this.orders[i]);
          }
        }
        this.currentPageData = currentPageData;
        return;
      }
      let filteredItemCount = 0;
      for (let i = 0; i < this.FilterList.length; i++) {
        let filter = 0;
        let c = this.orders[i];
        if (
          (this.Filter.filter1.length > 0 && c.saleOrderStatus == this.Filter.filter1) ||
          this.Filter.filter1.length == 0 ||
          (this.Filter.filter1 == "Faturalandı" && c.invoiced > 0) ||
          (this.Filter.filter1 == "Fatura Kesilecek" && c.invoiced == 0) // For Logo implementation
        ) {
          filter |= 1;
        }
        if ((this.Filter.filter2.length > 0 && c.saleOrderType == this.Filter.filter2) || this.Filter.filter2.length == 0) {
          filter |= 2;
        }
        if (this.Filter.filter3.length > 3) {
          if (this.handleFilters(c)) filter |= 4;
        } else {
          filter |= 4;
        }
        if (filter == 7) {
          this.FilterList[i].show = true;
          filteredItemCount++;
          if (currentPageData.length < this.pageSize) {
            if (filteredItemCount >= this.pageSize * this.actualPage && filteredItemCount < this.pageSize * (this.actualPage + 1)) currentPageData.push(this.orders[i]);
          }
        } else {
          this.FilterList[i].show = false;
        }
      }
      this.filteredItemCount = filteredItemCount;
      this.currentPageData = currentPageData;
    },
    handleFilters(i) {
      if (this.safeSearch(i.customer)) {
        this.matchedField = {
          field: "customer",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.customerPhone)) {
        this.matchedField = {
          field: "customerPhone",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.createdUser)) {
        this.matchedField = {
          field: "createdUser",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.assignedUser)) {
        this.matchedField = {
          field: "assignedUser",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(i.saleOrderId)) {
        this.matchedField = {
          field: "saleOrderId",
          value: this.Filter.filter3,
        };
        return true;
      } else if (this.safeSearch(this.convertToDateTime(i.createdDate))) {
        this.matchedField = {
          field: "createdDate",
          value: this.Filter.filter3,
        };
        return true;
      } else {
        if (i.products) {
          if (Array.isArray(i.products)) {
            for (var x = 0; x < i.products.length; x++) {
              if (this.safeSearch(i.products[x].productName)) {
                this.matchedField = {
                  field: "products",
                  value: this.Filter.filter3,
                };
                return true;
              }
            }
          } else {
            if (this.safeSearch(i.products.productName))
              this.matchedField = {
                field: "products",
                value: this.Filter.filter3,
              };
            return true;
          }
        } else return false;
      }
      return false;
    },
    paginate(d) {
      if (!this.orders || !Array.isArray(this.orders)) return;

      if (d) {
        if (this.pageSize * this.actualPage < this.filteredItemCount) {
          this.currentPage += 1;
        }
      } else {
        if (this.currentPage > 1) this.currentPage--;
      }
    },
    showAddNew() {
      this.addNewRegister = true;
    },
    sendEmailUpdateCompleted() {
      this.sendEmailPopupVisible = false;
    },
    assignUpdateCompleted(event, id, newStatus) {
      let status = JSON.parse(localStorage["salesStatusList"]).find((x) => x.id == newStatus).value;
      let so = this.orders.find((x) => x.saleOrderId == id);
      so.serviceStatus = status;
    },
    downloadRemainingPages: async function (currentPage, retries) {
      if (this.$route.name != this.name) return;
      if (!retries) retries = 0;
      //if (currentPage < this.pageCount && !navigator.isDebug ) {
      if (currentPage < this.pageCount) {
        this.autoRefreshModel.currentPage++;
        let r = await repository.postEntity("Sale/getOrders", this.autoRefreshModel);
        if (r && r.list) {
          this.orders = this.orders.concat(r.list);
          this.beautifyOrderList();
          this.renderItems();
          this.progressBarCurrent = currentPage;
          setTimeout(this.downloadRemainingPages, 250, ++currentPage);
        } else {
          //veri çekilirken hata oluşursa tekrar çekmeye çalış
          if (retries < 5) setTimeout(this.downloadRemainingPages, 1000, currentPage, ++retries);
          else {
            this.$vs.notify({
              title: "Hata",
              text: "Bağlantı hatası",
              color: "danger",
            });
          }
        }
      } else {
        this.autoRefresh = true;
        this.getNewAndUpdated();
        let interval = setInterval(() => {
          this.getNewAndUpdated();
        }, 1000 * this.autoRefreshSeconds);
        repository.timers(interval, "sale_refresh", "int", true);
      }
    },
    getNewAndUpdated: async function () {
      let now = new Date();
      if (this.$route.name != this.name) return;
      this.lastAutoRefresh = now;
      this.autoRefreshModel.lastUpdated = this.lastUpdated;
      let r = await repository.postEntity("Sale/getOrders", this.autoRefreshModel);
      if (r && r.lastUpdated) {
        let d1 = new Date(r.lastUpdated);
        let d2 = new Date(this.lastUpdated);
        if (d1 > d2) this.lastUpdated = r.lastUpdated;
      }
      if (r && r.list) {
        for (let i = 0; i < r.list.length; i++) {
          for (let j = this.orders.length - 1; j >= 0; j--) {
            if (this.orders[j].saleOrderId == r.list[i].saleOrderId) {
              this.orders.splice(j, 1);
              break;
            }
          }
        }
        for (let i = 0; i < r.list.length; i++) this.orders.unshift(r.list[i]);
        this.beautifyOrderList();
        this.renderItems();
      }
    },
    beautifyOrderList() {
      this.orders = repository.convertToJSON(this.orders, "products");
      this.FilterList = [];
      for (let i = 0; i < this.orders.length; i++) {
        this.FilterList.push({
          serviceId: this.orders[i].saleOrderId,
          show: true,
        });
      }
      this.filteredItemCount = this.FilterList.length;
      this.loading = false;
      this.displayPromptIfNotification();
    },

    getOrderList: async function () {
      let r = await repository.postEntity("Sale/getOrders", this.autoRefreshModel);
      if (!r) return;
      if (r.isSuccessful) {
        this.orders = r.list;
        this.lastUpdated = r.lastUpdated;
        this.pageCount = r.pageCount;
        this.progressBarCurrent = 1;
      } else {
        this.$vs.notify({
          title: "Hata Satış Listesi",

          text: (r && r.exceptionMessage && `${r.exceptionMessage} `) || "Bağlantı hatası",
          color: "danger",
        });
        return;
      }
      //setTimeout(this.downloadRemainingPages, 500, 1);
      this.beautifyOrderList();
      this.currentPageData = this.orders.slice(0, this.pageSize);
      return this.orders;
    },
    getNeighbours: async function () {
      this.neighbours = await repository.postEntity("HumanResource/getUser", { teamId: this.$store.state.userData.teamId }).then((r) => r.list);
    },
    getOrderStatusList: async function () {
      let r = await repository.getAll("Sale/getStatusList");
      if (!r) return;
      if (!r.isSuccessful) {
        this.$vs.notify({
          title: "Hata Satış Durumlar",
          text: `${r.exceptionMessage}`,
          color: "danger",
          icon: "warning",
        });
        return;
      } else {
        localStorage["salesStatusList"] = JSON.stringify(r.list);
        this.orderStatusList = r.list;
        return r.list;
      }
    },
    getOrderTypeList: async function () {
      let r = await repository.getAll("Sale/getOrderTypes");
      if (!r) return;
      if (!r.isSuccessful) {
        this.$vs.notify({
          title: "Hata Satış türleri",
          text: `${r.exceptionMessage}`,
          color: "danger",
          icon: "warning",
        });
      } else {
        localStorage["salesOrderTypeList"] = JSON.stringify(r.list);
        this.orderTypeList = r.list;
        return r.list;
      }
    },
    showDisplayPrompt(itemId) {
      itemId = parseInt(itemId);
      if (!isNaN(itemId)) {
        for (let i = 0; i < this.orders.length; i++) {
          if (itemId == this.orders[i].saleOrderId) {
            this.orderIdToEdit = itemId;
            this.displayPrompt = true;
            break;
          }
        }
      }
    },
    showAssignedPopUpMenu(itemId) {
      this.serviceId = itemId;
      this.assignedPopUpMenu = true;
    },
    openAddMessagePopup(id) {
      this.serviceId = id;
      this.addMessagePopupVisible = true;
    },
    openSendEmailPopup(item) {
      this.currentPopupItem = item;
      this.sendEmailPopupVisible = true;
    },
    openTransferPopup(id) {
      this.serviceId = id;
      this.transferPopupVisible = true;
    },
    convertToDateTime(val) {
      if (val == null || !val) return "";
      let x = new Date(val);
      if (x == null || typeof x != "object" || !x) return "";
      return x.toLocaleDateString() + " " + x.toLocaleTimeString();
    },
    //arama ve filtrelere göre listeye show=(true yada false) yazar
    createFilterList(filter) {
      if (filter) {
        this.Filter.filter1 = filter.filter1;
        this.Filter.filter2 = filter.filter2;
        this.Filter.expired = filter.expired;
      }
    },
    safeSearch(p1) {
      if (typeof p1 != "string") {
        p1 = JSON.stringify(p1);
      }
      p1 = (p1 && p1.toString().toLowerCase()) || "";
      let p2 = (this.Filter && this.Filter.filter3 && this.Filter.filter3.toString().toLowerCase()) || "";

      return p1.length > 0 && repository.convertToEnglish(p1).indexOf(p2) >= 0;
    },
    hideAssignedPopup() {
      this.assignedPopUpMenu = false;
    },

    hidePrompt() {
      this.displayPrompt = false;
    },

    sentDataAfteradd(d) {
      this.orders.unshift(d);
      this.currentPageData.unshift(d);
      this.currentPageData.pop();
      //this.getOrderList();
    },
    hideAddNew() {
      this.addNewRegister = false;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = false;
      } else {
        this.isSidebarActive = true;
      }
    },
    // eslint-disable-next-line
    toggleSidebar(x = false) {
      //if (!x && this.clickNotClose) return;
      this.isSidebarActive = !this.isSidebarActive;
    },
    displayPromptIfNotification() {
      let x = this.notification;
      if (x != null && x.name == this.name && parseInt(x.id) > 0) {
        this.showDisplayPrompt(x.id);
        this.$store.commit("PUSH_NOTIFICATION_TO_COMPONENT", null);
      }
    },
  },
  created() {
    if (this.$route.params != null && this.$route.name == "SaleByCustomerId" && this.$route.params.customerId > 0) {
      this.autoRefreshModel.customerId = this.$route.params.customerId;
    }

    if (this.$route.params != null && this.$route.name == "SaleByOrderId" && this.$route.params.saleOrderId > 0) {
      this.autoRefreshModel.id = this.$route.params.saleOrderId;
    }

    Promise.all([this.getUsers(), this.getOrderList(), this.getNeighbours(), this.getOrderStatusList(), this.getOrderTypeList(), this.GetStatusList()]);
  },
  beforeDestroy: function () {
    //repository.clearTimer("sale_refresh");
    window.removeEventListener("resize", this.handleWindowResize);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuesax/apps/sales.scss";
.sales-item .list-item-component {
  border-bottom: 1px solid #dae1e7;
}

.box-center {
  margin: 0 auto;
}
</style>
